import { createFileRoute } from "@tanstack/react-router";
import Landing from "@/pages/Landing";
import { buildHead } from "@/lib/seo";

export const Route = createFileRoute("/_app/")({
  head: () =>
    buildHead({
      title: "LohaLink — India's Trusted B2B Scrap Metal Marketplace",
      description:
        "LohaLink connects 3,400+ GST-verified Indian scrap yards with foundries. AI-benchmarked HMS, sponge iron & MS billet pricing with RBI-grade escrow.",
      canonical: "/",
    }),
  component: Landing,
});
